import { render, staticRenderFns } from "./TeamTaskForm.vue?vue&type=template&id=5f219a54&scoped=true&lang=pug&"
import script from "./TeamTaskForm.vue?vue&type=script&lang=js&"
export * from "./TeamTaskForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f219a54",
  null
  
)

export default component.exports